import React from 'react';
function AlarmWarning({ ...r }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...r}>
			<path
				fill="#272727"
				d="M2 18v-6a8 8 0 0116 0v6h1v2H1v-2h1zm2 0h12v-6a6 6 0 00-12 0v6zM9 0h2v3H9V0zm8.778 2.808l1.414 1.414-2.12 2.121-1.415-1.414 2.121-2.121zM.808 4.222l1.414-1.414 2.121 2.12L2.93 6.344.808 4.222zM5 12a5 5 0 015-5v2a3 3 0 00-3 3H5z"
			></path>
		</svg>
	);
}

export default AlarmWarning;
